module.exports = {
    title: 'contractsView-contractsView_precontractualConditionsTitle',
    order: 2,
    footer_text: '',
    position: 'middle',
    disableNext: 'depositExpired_pollingNextButtonDisabled',
    on_next_click: 'depositExpired_loadTermsAndConditionsLegalWindow',
	components: [
        ...(
                __CONTACT_CENTER__ ?
                [
                    {
                        id_component: 'legal-information',
                        legal_text: "mainDepositFlow-depositExpired_legalInformation",
                        isMandatoryRead: true,
                        readTextTitle: 'contractsView-legalInformation_readTextTitle',
                        readTextInfo: 'contractsView-legalInformation_readTextInfo',
                        getTextValues: 'depositexpired_getStep3MandatoryReadDisclaimerText',
                    }
                ] : [
                    {
                        id_component: 'step2-dic-viewer',
                    }
                ]
            )
	]
};
